<template>
  <div v-if="shopPageId && shopNav" class="storeHeader">
    <div id="gnb">
      <div class="home">
        <span><img :src="setting.logo" :alt="setting.title[lang]"></span>
      </div>
      <div v-if="roomKey" class="roomkeyNo notranslate">
        <span class=""
          :style="{ ...(globalIconType === 'border' ? skinStyle('mypageBg', 'border-color') : skinStyle('mypageBg', 'background-color')),
          ...skinStyle('mypageText', 'color') }">
          {{roomKey || ''}}
        </span>
      </div>
    </div>
    <div id="nav" ref="navScroll" class="nav">
      <div v-if="isDetailHeader" class="menu detailNav">
        <div class="item isActive">
          <div class="inner">
            <div class="activeAcc top" :style="{background: activeAcc('top')}"></div>
            <div class="menuName"
              :style="defaultActiveStyle">
              <div class="moduleLink">{{ detailItem.shopItemName && detailItem.shopItemName[lang] }}</div>
            </div>
            <div class="activeAcc bottom" :style="{background: activeAcc('bottom')}"></div>
          </div>
        </div>
      </div>
      <!-- 스토어 좌측메뉴 (1depth 카테고리) -->
      <div v-else class="menu">
        <div
          v-for="item in shopNav"
          :key="item.categoryId"
          :class="{isActive: isActive(item.categoryId)}"
          :ref="'navItem-' + item.categoryId"
          class="item">
          <div class="inner">
            <div v-if="isActive(item.categoryId)" class="activeAcc top" :style="{background: activeAcc('top')}"></div>
            <div class="menuName"
              :style="setActiveStyle(item.categoryId)">
              <router-link
                :to="{params: { shopCategoryId: item.categoryId }}"
                class="moduleLink">
                {{ item.categoryLabel[lang] }}
              </router-link>
            </div>
            <div v-if="isActive(item.categoryId)" class="activeAcc bottom" :style="{background: activeAcc('bottom')}"></div>
          </div>
        </div>
      </div>
      <!-- //스토어 좌측메뉴 (1depth 카테고리) -->
    </div>
    <div v-if="roomKey && callStaff && !isDetailHeader" class="callStaff">
      <button
        type="button"
        class="btn btnRound notranslate"
        :style="getDefaultBtn2Style"
        @click.stop="setCallStaff">
        {{ locale.call_staff }}
      </button>
    </div>

  </div>
</template>

<script>
export default {
  name: 'StoreHeader',
  props: [
    'locale',
    'lang',
    'responsive',
    'setting',
    'roomKey',
    'setting',
    'isPublic'
  ],
  computed: {
    globalIconType () {
      const pointcolors = this.setting && this.setting.pointcolors
      return (pointcolors && pointcolors.globalIconType) || 'bg'
    },
    activeMenuType () {
      const skin = this.setting && this.setting.skin
      return (skin && skin.activeMenuType) || 'default'
    },
    shopPageId () {
      return this.$route.params.shopPageId
    },
    shopCategoryId () {
      return this.$route.params.shopCategoryId
    },
    shopNav () {
      const shopPageId = this.shopPageId
      const category = shopPageId && this.$store.getters['shop/getCategoryNav'](shopPageId)
      return category
    },
    callStaff () {
      const shopPageId = this.shopPageId
      const settings = shopPageId && this.$store.getters['shop/getShopSettings'](shopPageId)
      const useCallStaff = settings && settings.isUseCallStaff
      return useCallStaff && 'call-staff'
    },
    currentCategoryIds () { // 1뎁스id를 포함한 하위 모든 id 추출한 배열
      const shopPageId = this.shopPageId
      const shopCategoryId = this.shopCategoryId
      const property = shopPageId && this.$store.getters['shop/getCategoryProperty'](shopPageId)
      const hasCategory = property && Object.values(property) && Object.values(property).find(x => x.includes(shopCategoryId))
      return hasCategory
    },
    pointColors () {
      return this.$store.getters['common/getPointColors']
    },
    colors () {
      const setting = this.$store.getters['common/getSetting']
      return {
        ...setting.colors,
        activeMenuBg: (setting.responsive && setting.responsive.tablet && setting.responsive.tablet.colors.activeMenuBg) || setting.colors.activeMenuBg || setting.colors.menuText,
        activeMenuText: (setting.responsive && setting.responsive.tablet && setting.responsive.tablet.colors.activeMenuText) || setting.colors.activeMenuText || setting.colors.menuBg
      }
    },
    getDefaultBtn2Style () {
      return this.$store.getters['common/getDefaultBtn2Style']
    },
    hiddenCategoryIds () {
      return this.$store.getters['shop/getHiddenGroup']
    },
    isDetailHeader () {
      return this.$store.getters['shop/getOpenDetailOption']
    },
    detailItem () {
      const getDetailItemInfo = this.$store.getters['shop/getDetailItemInfo']
      return getDetailItemInfo
    },
    defaultActiveStyle () {
      const colors = this.colors
      return {
        color: colors.activeMenuText || '#333333',
        backgroundColor: colors.activeMenuBg || '#ffffff'
      }
    },
  },
  watch: {
    shopCategoryId (categoryId) {
      // 이전 스크롤 예약 취소
      if (this.scrollTimer) {
        clearTimeout(this.scrollTimer)
      }

      // 80ms 후에 "마지막 categoryId" 기준으로 스크롤
      this.scrollTimer = setTimeout(() => {
        this.scrollToActive(categoryId)
      }, 80)
    }
  },
  mounted () {
    // 첫 진입 시에도 현재 활성 카테고리로 스크롤
    if (this.shopCategoryId) {
      this.scrollToActive(this.shopCategoryId)
    }
  },
  data () {
    return {
      scrollTimer: null
    }
  },
  methods: {
    // 활성화 메뉴가 보이도록 내비 스크롤 이동
    scrollToActive (categoryId) {
      this.$nextTick(() => {
        const container = this.$refs.navScroll
        const elRef = this.$refs['navItem-' + categoryId]
        if (!container || !elRef) return

        // v-for + :ref 조합에서 혹시 배열로 올 수 있으니 방어 코드
        const el = Array.isArray(elRef) ? elRef[0] : elRef

        // ① 가장 간단한 버전: scrollIntoView
        if (el && el.scrollIntoView) {
          el.scrollIntoView({
            // behavior: 'smooth', // 부드럽게
            block: 'nearest'    // 컨테이너 안에서 보이기만 하면 됨 (위/아래 딱 맞출 필요X)
          })
          return
        }

        // 구형 브라우저/환경용 수동 계산 버전 (옵션)
        const itemTop = el.offsetTop
        const itemBottom = itemTop + el.offsetHeight
        const viewTop = container.scrollTop
        const viewBottom = viewTop + container.clientHeight

        if (itemTop < viewTop) {
          // 위로 숨겨져 있으면 위쪽으로 올리기
          container.scrollTop = itemTop
        } else if (itemBottom > viewBottom) {
          // 아래로 숨겨져 있으면 아래쪽으로 내리기
          container.scrollTop = itemBottom - container.clientHeight
        }
      })
    },
    isActive (categoryId) {
      const ids = this.currentCategoryIds
      return ids && ids.includes(categoryId)
    },
    skinStyle (target, attr) {
      return this.pointColors(target, attr)
    },
    setActiveStyle (categoryId) {
      const colors = this.colors
      const isActive = this.isActive(categoryId)
      return isActive && {
        color: colors.activeMenuText || '#333333',
        backgroundColor: colors.activeMenuBg || '#ffffff'
      }
    },
    activeAcc (pos) {
      const color = this.colors.activeMenuBg || this.colors.menuText
      return `radial-gradient(circle 12px at ${pos} left ,#0000 96%,${color}) ${pos} left`;
    },
    setCallStaff () {
      this.$store.commit('shop/setCallStaff', true)
    }
  }
}
</script>